import { render, staticRenderFns } from "./_filter_by_document_id.vue?vue&type=template&id=fc07b67c&scoped=true&"
import script from "./_filter_by_document_id.vue?vue&type=script&lang=js&"
export * from "./_filter_by_document_id.vue?vue&type=script&lang=js&"
import style0 from "./_filter_by_document_id.vue?vue&type=style&index=0&id=fc07b67c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc07b67c",
  null
  
)

export default component.exports